export const expansionPanelStyle = {
    root: {
        border: '0',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {
        backgroundColor: '#e4e1e2'
    },
}